<app-auth-layout
    art="expired"
  headline="Pick up where you left off."
  blurb="Your sites, documents and reports are exactly as you left them."
  [branded]="!isStaffDoor"
>
  <app-brand-logo
    class="expired__logo"
    [src]="branding().logoUrl"
    [name]="branding().displayName"
  />

  <!-- On the apex host the tenant IS Davaco, so naming it would read "Davaco ·
       Davaco Customer Portal". Say who signs you in instead, exactly as the
       door does. -->
  @if (isStaffDoor) {
    <p class="expired__eyebrow">
      <app-microsoft-mark [size]="18" />
      Microsoft Identity · Davaco staff only
    </p>
  } @else {
    <p class="expired__eyebrow">{{ branding().displayName }} · Davaco Customer Portal</p>
  }

  @if (!failed()) {
    <h1 class="expired__title">Your session has expired</h1>
    <p class="expired__body">
      You were signed out to keep the account secure. Signing in again takes you straight
      back.
    </p>
  } @else {
    <h1 class="expired__title">We couldn't reach sign-in</h1>
    <p class="expired__body">
      Something went wrong on the way to secure sign-in. This is usually temporary.
    </p>
  }

  <!-- On the apex host this hands off to Microsoft, so it wears Microsoft's
       button and mark exactly as the door does — the accent would misrepresent
       where the click goes. A customer's sign-in goes to their own branded
       Universal Login, so that one takes the tenant accent. -->
  @if (isStaffDoor) {
    <button
      type="button"
      class="expired__action expired__action--microsoft"
      [disabled]="pending()"
      (click)="signInAgain()"
    >
      <app-microsoft-mark [size]="18" />
      {{ failed() ? 'Try again' : 'Sign in again' }}
    </button>
  } @else {
    <button
      type="button"
      class="expired__action expired__action--brand"
      [disabled]="pending()"
      (click)="signInAgain()"
    >
      {{ failed() ? 'Try again' : 'Sign in again' }}
    </button>
  }

  <div class="expired__rule"></div>

  <p class="expired__link"><span>Need help?</span><span>Contact Davaco support</span></p>
</app-auth-layout>
